import { useState } from "react";
import SideNavLayout from "../../Sidenav/SideNavLayout";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import InsightsIcon from "@mui/icons-material/Insights";
import WarningIcon from "@mui/icons-material/Warning";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TimelineIcon from "@mui/icons-material/Timeline";
import { taboptions } from "../utils/safetyanalyticsoptions";
import KeyInsights from "./keyinsights";
import Incidents from "./incidents";
import BbsData from "./bbsdata";
import Trends from "./trends";
import { clock, closeeyegreen, downarrowgreen, infoblue, slips, uparrowred, Voilationred } from "../utils/safetysvgs/safetysvg";

const SafetyAnalytics = () => {
  const [selectedOption, setSelectedOption] = useState("Key Insights");



  return (
    <SideNavLayout>
              <div className="p-2  max-h-[90vh] overflow-y-auto space-y-4"
                style={{scrollbarWidth:"none"}}>
        {/* Top Header Row */}
        <div className="flex flex-col text-start md:flex-row justify-between items-start md:items-center">
          <div>
            <h1 className="text-xl font-semibold text-[#0A0A0A]">
              Safety Analytics Dashboard
            </h1>
            <p className="text-sm font-normal text-[#717182]">
              Comprehensive safety performance metrics
            </p>
          </div>

          <div className="mt-3 md:mt-0 flex items-center gap-2 rounded-[6.75px] border border-[rgba(0,0,0,0.10)] bg-white px-4 py-2 text-sm text-[#0A0A0A] shadow-sm">
           {clock}
            <span>
              Last Updated: <span className="font-medium">2 hours ago</span>
            </span>
          </div>
        </div>

        {/* Analytics Cards */}
        <div className="flex flex-wrap gap-4 items-stretch">
          {/* Card 1 */}
          <div className="relative h-full rounded-[8.75px] border border-[#BEDBFF] bg-[#FEF2F2] p-4 w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)] max-w-full">
            <div className="absolute top-2 right-2 p-[6px] rounded-full bg-[#DBEAFE]">
             {infoblue}
            </div>
            <div className="text-sm text-start font-semibold text-[#155DFC]">May 2025 Incidents</div>
            <div className="flex items-center text-xl font-bold mt-1">
              <span className="text-[#155DFC] font-bold text-xl">3</span>
              <span className="ml-1 flex items-center text-xs font-normal text-[#00C950]">
               {downarrowgreen} -25%
              </span>
            </div>
            <div className="text-sm text-start text-[#155DFC] mt-1">vs. previous month</div>
          </div>

          {/* Card 2 */}
          <div className="relative h-full rounded-[8.75px] border border-[#FEE685] bg-[#FFFBEB] p-4 w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)] max-w-full">
            <div className="absolute top-2 right-2 p-[6px] rounded-full bg-[#FEF3C6]">
            {slips}
            </div>
            <div className="text-sm text-start font-semibold text-[#E17100]">Most Common: Slips & Trips</div>
            <div className="flex items-center text-xl font-bold mt-1">
              <span className="text-[#E17100] font-bold text-xl">2</span>
              <span className="ml-1 flex items-center text-xs font-normal text-[#FB2C36]">
               {uparrowred} -1%
              </span>
            </div>
            <div className="text-sm text-start text-[#E17100] mt-1">67% of May incidents</div>
          </div>

          {/* Card 3 */}
          <div className="relative h-full rounded-[8.75px] border border-[#B9F8CF] bg-[#FEF2F2] p-4 w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)] max-w-full">
            <div className="absolute top-2 right-2 p-[6px] rounded-full bg-[#DBEAFE]">
            {closeeyegreen}
            </div>
            <div className="text-sm text-start font-semibold text-[#00A63E]">Near Misses</div>
            <div className="flex items-center text-xl font-bold mt-1">
              <span className="text-[#00A63E] font-bold text-xl">6</span>
              <span className="ml-1 flex items-center text-xs font-normal text-[#00A63E]">
               {downarrowgreen} -25%
              </span>
            </div>
            <div className="text-sm text-start text-[#00A63E] mt-1">reported in May</div>
          </div>

          {/* Card 4 */}
          <div className="relative h-full rounded-[8.75px] border border-[#FFC9C9] bg-[#FEF2F2] p-4 w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)] max-w-full">
            <div className="absolute top-2 right-2 p-[6px] rounded-full bg-[#E0E7FF]">
            {Voilationred}
            </div>
            <div className="text-sm text-start font-semibold text-[#E7000B]">PPE Violations</div>
            <div className="flex items-center text-xl font-bold mt-1">
              <span className="text-[#E7000B] font-bold text-xl">8</span>
              <span className="ml-1 flex items-center text-xs font-normal text-[#FB2C36]">
              {uparrowred} -25%
              </span>
            </div>
            <div className="text-sm text-start text-[#E7000B] mt-1">during May inspections</div>
          </div>
        </div>

        {/* Options Row */}
    {/* Options Row */}
<div className="w-full flex flex-wrap rounded-[12.75px] bg-[#DBEAFE] p-1">
  {taboptions.map(({ label, icon }) => {
    const isSelected = selectedOption === label;
    return (
      <button
        key={label}
        onClick={() => setSelectedOption(label)}
        className={`flex-1 flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium rounded-[12.75px] transition-colors duration-200
          ${isSelected
            ? "bg-white text-[#0A0A0A]"
            : "bg-transparent text-[#0A0A0A] "}`}
      >
        {icon}
        {label}
      </button>
    );
  })}
</div>
<div>
{selectedOption==='Key Insights'?<>
<KeyInsights/>
</>: selectedOption==='Incidents'?<><Incidents/></>: selectedOption==='BBS Data'?<><BbsData/></>:<><Trends/></>}

</div>

      </div>
    </SideNavLayout>
  );
};

export default SafetyAnalytics;
